import { IconChevronDown } from '@websolutespa/bom-mixer-icons';
import React from 'react';
import styled from 'styled-components';

const StyledIcon = styled(IconChevronDown)`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-left: -2.8rem;
  align-self: center;
  pointer-events: none;
`;

export const SelectLegacyIcon = React.memo(StyledIcon);
